<div style="position: fixed; top: 16px; right: 24px; z-index: 100;">
  <app-language-switcher></app-language-switcher>
</div>
<div class="container mt-5" style="max-width: 400px;">
  <h3 class="mb-4 login">{{ 'LOGIN.TITLE' | translate }}</h3>

  <div *ngIf="errorMsg" class="alert alert-danger">
    {{ errorMsg }}
  </div>

  <div *ngIf="sessionMessageKey" class="alert alert-info" role="status">
    {{ sessionMessageKey | translate }}
  </div>

  <form (ngSubmit)="login()">
    <div class="mb-3 login">
      <label for="account" class="form-label">{{ 'LOGIN.ACCOUNT' | translate }}</label>
      <input
        id="account"
        name="account"
        class="form-control"
        [(ngModel)]="account"
        required
      />
    </div>

    <div class="mb-3 login">
      <label for="password" class="form-label">{{ 'LOGIN.PASSWORD' | translate }}</label>
      <div class="input-group">
        <input
          id="password"
          name="password"
          [type]="showPassword ? 'text' : 'password'"
          class="form-control"
          [(ngModel)]="password"
          required
        />
        <button
        class="btn btn-outline-secondary border-start-0"
        type="button"
        class="eye-btn"
        (click)="toggleShowPassword()"
        [attr.aria-label]="showPassword ? ('LOGIN.HIDE_PASSWORD' | translate) : ('LOGIN.SHOW_PASSWORD' | translate)"
        >
          <img
            [src]="showPassword ? 'assets/images/open-eye.svg' : 'assets/images/close-eye.svg'"
            alt="Toggle password visibility"
            class="eye-icon"
          />
        </button>
      </div>
    </div>

    <button type="submit" class="btn btn-primary w-100">{{ 'LOGIN.SUBMIT' | translate }}</button>
  </form>
</div>
<!--footer-->
<div id="footer">
  <div class="login-logos">
    <img src="../../../assets/images/mohw_logo.png" class="logomark" alt="" />
    <img src="../../../assets/images/itri_logo.png" class="logomark" alt="" />
  </div>
</div>
<!--content end-->